// extracted by mini-css-extract-plugin
module.exports = {"section":"ReviewExportSection_section__Bc66C","heading":"ReviewExportSection_heading__NlnYx"};